import Maintenance from "../Maintenance";

function AuthLayout(props){
    return ( props.maintenance ? <Maintenance/> : props.children )
}

export default AuthLayout; 